export default "__VITE_ASSET__43acccd6__"